import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

function getUrl(reportIds: string[]) {
  if (reportIds.length === 1) {
    return `/staff/fulfillment/r/${reportIds[0]}`;
  }
  return `/staff/fulfillment?search=report:${reportIds.join("|")}`;
}

/**
 * Navigate to the fulfillment reports page with the given report IDs.
 * If there is only one report, navigate to the report page.
 * If there are multiple reports, navigate to the search page with the report IDs.
 * @param reportIds - The IDs of the reports to navigate to.
 * @returns A function that navigates to the fulfillment reports page with the given report IDs.
 */
export const useNavigateToFulfillmentReports = ({
  openInNewTab,
}: {
  openInNewTab: boolean;
}) => {
  const navigate = useNavigate();
  const handleNavigate = useCallback(
    (reportIds: string[]) => {
      const url = getUrl(reportIds);
      if (openInNewTab) {
        window.open(url, "_blank");
      } else {
        navigate(url);
      }
    },
    [navigate, openInNewTab]
  );

  return handleNavigate;
};
